import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de bactericidas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function Bactericidas(props) {
  useEffect(() => {
    const title = 'bactericidas.bactericidas';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.BACTERICIDA}
      insumoURL='bactericidas'
      viewKey='bactericidas'
      deleteMessageSucess={formatMessage(
        'bactericidas.bactericidasRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('bactericidas.falhaAoExcluirBactericidas')}
      mensagemDelete={formatMessage('bactericidas.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'bactericidas';
  })[0].content
});

export default connect(mapStateToProps)(Bactericidas);
